import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import LottieLoader from 'components/containers/common/LottieLoader';

import heartIcon from 'images/heart-icon.png'
import heartIconActive from 'images/heart_icon.png'
import commentIcon from 'images/comment_icon.png'

export default function CommunityPostFooter({
    post,
    lottieOptions,
    isLikeAnimation,
    currPostNo,
    onAddLikeClick,
    onDeleteLikeClick,
    onCommentClick
}) {
    return (
        <ButtonList>
            <ButtonItem>
                {post?.liked_post ? (
                    isLikeAnimation && post['no'] === currPostNo ? (
                        <AnimationBlock>
                            <LottieLoader lottieOptions={lottieOptions} style={{ position: 'absolute',width: 'calc(100vw * (50.2 / 375))', height: 'calc(100vw * (45.8 / 375))', top: '-100%', left: '-100%', transform: 'translate(9.5%, 10.5%)'}}/> 
                        </AnimationBlock>
                    ) : (
                        <HeartButton onClick={() => onDeleteLikeClick(post)}>
                            <img src={heartIconActive}/>
                        </HeartButton>
                    )
                ) : (
                    <HeartButton onClick={() => onAddLikeClick(post)}>
                        <img src={heartIcon}/>
                    </HeartButton> 
                )}
                <CountNum>{post['total_like']}</CountNum>
            </ButtonItem>
            <ButtonItem>
                <CommentButton onClick={onCommentClick ? () => onCommentClick(post['no']) : null}>
                    <img src={commentIcon}/>
                </CommentButton>
                <CountNum>{post['total_comment'] !== null ? post['total_comment'] : 0}</CountNum>
            </ButtonItem>
        </ButtonList>
    )
}

const ButtonList = styled.div`
    display: flex;
    align-items: center;
    padding: calc(100vw * (11 / 375)) 0;
    width: 100%;
`;

const ButtonItem = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: calc(100vw * (10 / 375));

    &:first-of-type {
        margin: 0
    }
`;

const HeartButton = styled.button`
    width: calc(100vw * (20.1 / 375));
    height: calc(100vw * (18.9 / 375));
`;

const CommentButton = styled.button`
    width: calc(100vw * (17.9 / 375));
    height: calc(100vw * (17.9 / 375));
`;

const CountNum = styled.span` 
    font-size: calc(100vw * (12 / 375));
    font-weight: 500;
    color: #7f7f7f;
    margin-left: calc(100vw * (3.5 / 375));
`;

const AnimationBlock = styled.div`
    position: relative;
    width: calc(100vw * (20.1 / 375));
    height: calc(100vw * (18.9 / 375));
`;